import autobind from 'autobind-decorator';
import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import type { PAGE_TYPE } from '@core/utils/event-bus';

@Injectable()
export class ContextService {
  public pageType: PAGE_TYPE = '';
  constructor() {
    this.pageType = '';
  }
  public setPageType(pageType: PAGE_TYPE) {
    this.pageType = pageType;
  }
}
